export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रतिपक्षी की जानकारी"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आईडी / खाता / ईमेल / फोन"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आईडी / क्रिप्टो-पता / ईमेल / फोन"])}
}